/* French presentation for Shopify-owned controls when previewing on the US store.
   Consent state, submissions, product data and market selection remain native. */
(() => {
  const privacyText = new Map([
    ['Cookie consent', 'Votre choix de cookies'],
    ['Privacy Policy', 'Politique de confidentialité'],
    ['Manage preferences', 'Gérer mes préférences'],
    ['Accept', 'Accepter'], ['Decline', 'Refuser'],
    ['Cookie and privacy preferences', 'Préférences de cookies et de confidentialité'],
    ['Accept all', 'Tout accepter'], ['Decline all', 'Tout refuser'],
    ['Save my choices', 'Enregistrer mes choix'],
    ['You control your data', 'Vous gardez le contrôle de vos données'],
    ['Learn more about the cookies we use, and choose which cookies to allow.', 'Découvrez les cookies que nous utilisons et choisissez ceux que vous autorisez.'],
    ['Required', 'Nécessaires'], ['Personalization', 'Personnalisation'],
    ['Marketing', 'Marketing'], ['Analytics', 'Statistiques'],
    ['These cookies are necessary for the site to function properly, including capabilities like logging in and adding items to the cart.', 'Ces cookies sont nécessaires au bon fonctionnement du site, notamment pour vous connecter et ajouter des articles au panier.'],
    ['These cookies store details about your actions to personalize your next visit to the website.', 'Ces cookies mémorisent vos actions pour personnaliser votre prochaine visite sur le site.'],
    ['These cookies are used by us and our partners, including Shopify, to optimize marketing communications and show you ads on other websites.', 'Nous et nos partenaires, dont Shopify, utilisons ces cookies pour améliorer nos communications marketing et vous présenter des publicités sur d’autres sites.'],
    ['These cookies help us understand how you interact with the site. We use this data to identify areas to improve.', 'Ces cookies nous aident à comprendre votre utilisation du site afin de déterminer les améliorations à apporter.'],
    ['We and our partners, including Shopify, use cookies and other technologies to personalize your experience, show you ads, and perform analytics, and we will not use cookies or other technologies for these purposes unless you accept them. Learn more in our', 'Nous et nos partenaires, dont Shopify, utilisons des cookies et d’autres technologies pour personnaliser votre expérience, vous présenter des publicités et réaliser des statistiques. Nous ne les utilisons à ces fins qu’avec votre accord. Pour en savoir plus, consultez notre'],
    ['Close', 'Fermer'], ['Close dialog', 'Fermer la fenêtre'],
  ]);
  function translatePrivacy() {
    document.querySelectorAll('#shopify-pc__banner, #shopify-pc__prefs__dialog').forEach(root => {
      const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
      let node;
      while ((node = walker.nextNode())) {
        const key = node.nodeValue.trim();
        const translated = privacyText.get(key);
        if (translated && translated !== key) node.nodeValue = node.nodeValue.replace(key, translated);
      }
      root.querySelectorAll('[aria-label]').forEach(element => {
        const text = privacyText.get(element.getAttribute('aria-label'));
        if (text) element.setAttribute('aria-label', text);
      });
    });
  }
  let scheduled = false;
  new MutationObserver(() => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => { scheduled = false; translatePrivacy(); });
  }).observe(document.body, {childList: true, subtree: true, characterData: true});
  translatePrivacy();
  if (typeof Intl.DisplayNames === 'function') {
    const countries = new Intl.DisplayNames(['fr'], {type: 'region'});
    document.querySelectorAll('button[name="country_code"]').forEach(button => {
      const country = countries.of(button.value);
      const currency = button.textContent.match(/\([A-Z]{3}\)/)?.[0] || '';
      if (country) button.textContent = `${country} ${currency}`.trim();
    });
    document.querySelectorAll('[data-lvn-country]').forEach(label => {
      label.textContent = `${countries.of(label.dataset.lvnCountry)} | ${label.dataset.lvnCurrency}`;
    });
  }
})();
